import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _CloseSmall;
var _excluded = ["children", "className", "hideCloseButton"];
import { clsx } from 'clsx';
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';
import { Modal } from "../Modal";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DialogBase = function DialogBase(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$hideCloseButton = _ref.hideCloseButton,
    hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Modal, _objectSpread(_objectSpread({
    role: "dialog",
    className: "tw-flex tw-justify-center tw-place-items-center tw-px-1.6"
  }, rest), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: clsx('tw-relative', 'tw-rounded tw-max-h-[90vh]',
      // SPACING
      'tw-bg-neutral-light-100 tw-shadow-01',
      // COLORS
      'tw-overflow-y-auto', className),
      children: [!hideCloseButton && /*#__PURE__*/_jsx("button", {
        className: "tw-absolute tw-p-[0.6rem] tw-top-1.2 tw-right-1.2",
        type: "button",
        onClick: rest.onDismiss,
        children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
          size: 24,
          className: "tw-text-neutral-light-700"
        }))
      }), children]
    })
  }));
};